(() => {
  const container = document.querySelector('product-info');
  if (!container) return;
  const sid = container.getAttribute('data-section');
  const variantsEl = document.getElementById(`LioraVariants-${sid}`);
  if (!variantsEl) return;

  const variants = JSON.parse(variantsEl.textContent || '[]');
  const badge = container.querySelector('.liora-badge.-discount');
  if (!badge) return;

  // 丸め方法（四捨五入/切り捨て/切り上げ）: 'round' | 'floor' | 'ceil'
  const roundMethod = 'round';
  const R = { round: Math.round, floor: Math.floor, ceil: Math.ceil }[roundMethod];

  function updateFromVariantId(id) {
    const v = variants.find(x => String(x.id) === String(id));
    if (!v) return;
    const price = Number(v.price || 0);
    const compare = Number(v.compare_at_price || 0);

    if (compare > price) {
      const pct = R(((compare - price) / compare) * 100);
      badge.textContent = `${pct}%OFF`;
      badge.style.display = '';
    } else {
      badge.style.display = 'none';
    }
  }

  const idInput = container.querySelector('form[action*="/cart/add"] [name="id"]');
  if (idInput) {
    updateFromVariantId(idInput.value);
    idInput.addEventListener('change', e => updateFromVariantId(e.target.value));
  }

  // 念のため、フォーム内の選択肢変更も拾う
  container.addEventListener('change', e => {
    const target = e.target;
    if (target && target.name === 'id') updateFromVariantId(target.value);
  });
})();
